// components 배럴을 거치면 모든 도메인 컴포넌트가 메인 번들로 딸려오므로 직접 import 한다
import * as ModalComponent from 'components/modal';
import React, { useEffect } from 'react';

import { Outlet, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'stores';
import {
  clearAll,
  closeAlert,
  closeConfirm,
  closeModal,
  confirm,
} from 'stores/ui';

function Base() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const {
    loading,
    isOpenAlert,
    alertContent,
    isOpenConfirm,
    confirmContent,
    modals,
    yesTitle,
    noTitle,
  } = useAppSelector((state) => state.ui);

  useEffect(() => {
    dispatch(clearAll());
  }, [location]);

  useEffect(() => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }, []);

  return (
    <>
      <Outlet />
      <ModalComponent.Portal>
        {modals.map((data, idx) => (
          <ModalComponent.Background key={idx}>
            <ModalComponent.Modal
              title={data.title}
              footer={data.footer}
              size={data.size}
              handleClose={() => dispatch(closeModal())}
            >
              {data.body}
            </ModalComponent.Modal>
          </ModalComponent.Background>
        ))}

        {isOpenAlert && (
          <ModalComponent.Background onClick={() => dispatch(closeAlert())}>
            <ModalComponent.Alert onClose={() => dispatch(closeAlert())}>
              {alertContent}
            </ModalComponent.Alert>
          </ModalComponent.Background>
        )}
        {isOpenConfirm && (
          <ModalComponent.Background onClick={() => dispatch(closeConfirm())}>
            <ModalComponent.Confirm
              yesTitle={yesTitle}
              noTitle={noTitle}
              onConfirm={() => dispatch(confirm())}
              onClose={() => dispatch(closeConfirm())}
            >
              {confirmContent}
            </ModalComponent.Confirm>
          </ModalComponent.Background>
        )}

        {loading && <ModalComponent.Spiner />}
      </ModalComponent.Portal>
    </>
  );
}

export default Base;
